export const environment = {
  production: false,
  apiURL: "https://api.iolr-monitoring.org/api",
  apiGraphURL: "https://data-processor-api.iolr-monitoring.org",
  googleMapsApiKey: "AIzaSyBMHq1qsna1YpSRd_K2sdTjSBxCNGLP1Yg",
};
